import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { AI_INSIGHTS_UPDATE_GATE, REPORTING_ENABLEMENT_SRV_REPORT_PRESETS_GATE, SRV_VIEW_MODE_REMIXES_GATE } from '../../../../constants/gates';
import { getIsInsightsShown } from '../../fullPage/report-ai-assistant-insights/utils';
import { REPORT_PRESETS_CONFIG } from './report-presets/reportPresetsConfig';
import { REPORT_PRESET_TABS } from './report-presets/reportPresetConstants';
import { useGate } from '../../../../hooks/useGate';
export const getShouldShowAIReportSummary = ({
  report,
  userInfo
}) => {
  var _userInfo$gates;
  return getIsInsightsShown(report, userInfo) && (userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(AI_INSIGHTS_UPDATE_GATE));
};
export const getShouldShowAIReportPresets = ({
  report,
  userInfo
}) => {
  var _userInfo$gates2;
  if (!isReportEligibleForReportRemixes({
    report
  })) {
    return false;
  }
  return userInfo === null || userInfo === void 0 || (_userInfo$gates2 = userInfo.gates) === null || _userInfo$gates2 === void 0 ? void 0 : _userInfo$gates2.includes(REPORTING_ENABLEMENT_SRV_REPORT_PRESETS_GATE);
};
export function isReportEligibleForReportRemixes({
  report
}) {
  const isAnyPresetValidForReport = Object.values(REPORT_PRESET_TABS).some(tab => REPORT_PRESETS_CONFIG[tab].isReportValid(report));
  return isConfigReport(report) && isAnyPresetValidForReport;
}
export function useIsEligibleForViewModeReportRemixes(report) {
  const isViewModeRemixesEnabled = useGate(SRV_VIEW_MODE_REMIXES_GATE);
  return isViewModeRemixesEnabled && isReportEligibleForReportRemixes({
    report
  });
}